<div class="splash-card-header w-100 text-center">
    <img
        class="splash-card-header-logo"
        src="/assets/icons/logo_header_dark.png"
    />
    <div class="splash-card-header-page-not-found"
        >Oops! That page couldn't be found.</div
    >
</div>
<div class="splash-card-body">
    Please head back to <a [routerLink]="['/']">the homepage</a>.
</div>
